import { render, staticRenderFns } from "./addFilter.vue?vue&type=template&id=04d8d72c"
import script from "./addFilter.vue?vue&type=script&lang=ts"
export * from "./addFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports